import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { PolizzeComponent } from 'src/app/anagrafiche/polizze/polizze.component';
import { FormGroup, Validators } from '@angular/forms';
import { Incarico } from 'src/app/models/incarico';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => PolizzaPickerComponent) },
  ],
  selector: 'polizza-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class PolizzaPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(PolizzeComponent, { data: { selectionMode: true, incarico: this.incarico } }).afterClosed();
  };

  @Input() incarico?: Incarico;

  getRoute = (id) => `/polizze/${id}`;

  parts: FormGroup = this.fb.group({
    id: [''],
    compagnia_id: [],
    humanIdentifier: ['', Validators.required],
    original_model: [],
  });
}